import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
})
export class ConfirmModalComponent {

  callbackConfirm: () => void;
  callbackCancel: () => void;

  constructor(private bsModalRef: BsModalRef) {}

  confirm() {
    if (typeof this.callbackConfirm === typeof(Function)) {
      this.callbackConfirm();
    }

    this.close();
  }

  cancel() {
    if (typeof this.callbackCancel === typeof(Function)) {
      this.callbackCancel();
    }

    this.close();
  }

  close() {
    this.bsModalRef.hide();
  }
}
